import newTypes from './proText.newtypes';
import oldTypes from './proText.oldtypes';

export default {...newTypes, ...oldTypes};